import { FC } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

import './WorkOrderSheet.scss'

import styled from 'styled-components'
import { SimutechBlue } from '../../styles/Theme'
import { WorkOrder } from '../../Types'


type Props = {
    workOrder: WorkOrder
}

const date = new Date().toLocaleDateString(navigator.language)
const workOrderNumber = '00' + (Math.round(Math.random() * 9000) + 1000).toFixed(0)

const WorkOrderSheet: FC<Props> = ({ workOrder }: Props) => {
    const { StatusOfRepair, ReportedProblem, Comment } = workOrder

    return (
        <>
            <Container className="workOrder" fluid={true}>
                <Row className="paper">
                    <Col className="paper-inner">
                        <Row className="workOrderInfo">
                            <Col sm={{ span: 5 }} className="left-column">
                                <Row className="input-row">
                                    <Col sm={{ span: 7 }}>
                                        {'Work Order #:'}
                                    </Col>
                                    <Col sm={{ span: 5 }}>
                                        <WorkOrderField>
                                            {workOrderNumber}
                                        </WorkOrderField>

                                    </Col>
                                </Row>
                                <Row className="input-row">
                                    <Col sm={{ span: 7 }}>
                                        {'Date:'}
                                    </Col>
                                    <Col sm={{ span: 5 }}>
                                        <WorkOrderField>
                                            {date}
                                        </WorkOrderField>
                                    </Col>
                                </Row>
                                <Row className="input-row">
                                    <Col sm={{ span: 7 }}>
                                        {'Status of Repair:'}
                                    </Col>
                                    <Col sm={{ span: 5 }}>
                                        <WorkOrderField>
                                            {StatusOfRepair || <Skeleton />}
                                        </WorkOrderField>

                                    </Col>
                                </Row>
                                <Row className="location-row">
                                    <Col className="location">
                                        <WorkOrderField style={{ height: '100%' }}>
                                            <div><strong>{'Location:'}</strong></div>
                                            <div>{'ACE Growers'}</div>
                                            <div>{'114 Port Street'}</div>
                                            <div>{'Torosonto ON N2F 3PO'}</div>
                                        </WorkOrderField>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={{ span: 7 }}>
                                <WorkOrderField style={{ height: '100%' }}>
                                    <div><strong>{'Reported Problem:'}</strong></div>
                                    <div>{ReportedProblem || <Skeleton count={7} />}</div>
                                </WorkOrderField>

                            </Col>
                        </Row>
                        <Row className="comments">
                            <Col sm={{ span: 12 }}>
                                <WorkOrderField style={{ height: '100%' }}>
                                    <div><strong>{'Comments'}</strong></div>
                                    <div>{Comment === undefined ? <Skeleton count={4} /> : Comment}</div>
                                </WorkOrderField>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

        </>
    )
}
export default WorkOrderSheet


const WorkOrderField = styled.div`
    border: 1px solid ${SimutechBlue};
    margin: 0 2px;
    padding: 1px 3px;
    width: 100%;    
    background-color: white;
    overflow: hidden;
`